import { EventStage } from '../models/event.interface';
import { TargetingType } from '../models/promotion.interface';

export function eventStageLabel(value: EventStage) {
    switch (value) {
        case EventStage.INCOMPLETE:
            return 'In Progress';
        case EventStage.AWAITING_APPROVAL:
            return 'Awaiting Approval';
        case EventStage.APPROVED:
            return 'Approved';
        default:
            return value;
    }
}

export function targetingLabel(value: TargetingType) {
    switch (value) {
        case TargetingType.GeoTargeted:
            return 'Geo Targeted';
        case TargetingType.National:
            return 'National';
        case TargetingType.UserTargeted:
            return 'User Targeted';
        default:
            return value;
    }
}
